module.exports = __webpack_public_path__ + "a932aae7245eaddeb790f6157c6d3e8e.pdf";